import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const ShapeXIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="shapeX" ref={ref} {...props}>
      <path d="M20.53,19.47a.75.75,0,0,1,0,1.06.74.74,0,0,1-.53.22.73.73,0,0,1-.53-.22L12,13.06,4.53,20.53a.74.74,0,0,1-.53.22.73.73,0,0,1-.53-.22.75.75,0,0,1,0-1.06L10.94,12,3.47,4.53A.75.75,0,1,1,4.53,3.47L12,10.94l7.47-7.47a.75.75,0,1,1,1.06,1.06L13.06,12Z" />
    </Icon>
  ),
) as IconWithRender;

ShapeXIcon.displayName = 'ShapeXIcon';
ShapeXIcon.renderIcon = (props) => <ShapeXIcon {...props} />;
export default ShapeXIcon;
